import { createSettingValue } from './setting-value-impl';
export const createSetting = (rawSetting, tupleWasm, configWasm) => {
    return new SettingImpl(rawSetting.name, rawSetting.value, rawSetting.details, tupleWasm, configWasm, false);
};
export const createPreencryptedSetting = (name, encryptedValue, details, tupleWasm, configWasm) => {
    return new SettingImpl(name, encryptedValue, details, tupleWasm, configWasm, true);
};
class SettingImpl {
    name;
    tupleValue;
    settingDetails;
    tupleWasm;
    configWasm;
    isValuePreencrypted;
    constructor(name, tupleValue, settingDetails, tupleWasm, configWasm, isValuePreencrypted) {
        this.name = name;
        this.tupleValue = tupleValue;
        this.settingDetails = settingDetails;
        this.tupleWasm = tupleWasm;
        this.configWasm = configWasm;
        this.isValuePreencrypted = isValuePreencrypted;
    }
    fullName() {
        return this.name;
    }
    value() {
        return createSettingValue(this.tupleValue, this.tupleWasm, this.configWasm);
    }
    details() {
        return this.settingDetails;
    }
    rawValue() {
        return this.tupleValue;
    }
    isPreencrypted() {
        return this.isValuePreencrypted;
    }
}
